import { Alert, Box, Button, Card, Menu, Paper, Stack, Typography } from '@mui/material';

import { createNoFlip } from './createNoFlip';

/**
 * Ready-made NoFlip twins of the MUI primitives the app pins direction on.
 *
 * Import these instead of calling `createNoFlip` again per file — one shared
 * styled component per primitive keeps the Emotion cache small and guarantees
 * every page pins direction the same way.
 *
 * Reach for `createNoFlip` directly only for a component that has no twin here
 * (and add it here if a second page needs the same one).
 */
export const NoFlipBox = createNoFlip(Box);
export const NoFlipStack = createNoFlip(Stack);
export const NoFlipPaper = createNoFlip(Paper);
export const NoFlipCard = createNoFlip(Card);
export const NoFlipTypography = createNoFlip(Typography);
export const NoFlipAlert = createNoFlip(Alert);
export const NoFlipButton = createNoFlip(Button);
// Pins the popover root, so MenuItems stay direct children of MenuList and
// keyboard navigation keeps working.
export const NoFlipMenu = createNoFlip(Menu);
